<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #EEEEEE; padding-top: 4px;">
    <div class="row">
      <a class="close-challenge d-flex justify-content-end mt-1 mb-1" href="/dashboard">
        X
      </a>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="budget-amount-title">{{ $t('CHOOSE_BET_AMOUNT') }}</div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div class="col-4" v-for="(amount, index) in budgetAmounts" :key="index">
            <div class="budget-amount"
                 :class="{'budget-amount-active': amount === selectBudgetAmount}"
                 @click="changeBudgetAmount(amount)"
            >
              <img src="@/assets/img/coin.png" :alt="amount"> {{ convertNumberToLangWise(amount) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 mt-2">
        <div class="challenge-type-title">
          {{ $t('TYPE_OF_CHALLENGE') }}
        </div>
      </div>
      <div class="col-lg-12 mb-2">
        <div class="d-flex justify-content-between">
          <argon-button fullWidth color="danger"
                        variant="gradient"
                        class="my-3 mb-1 me-2"
                        @click="challengeTypeChange('single')"
                        :style="[Object.keys(this.challengeTypes)[0] === selectChallengeType
                          ? {'background': '#8435e8', 'color': '#FFFFFF', 'font-weight': 'bold'}
                          : {'background': '#FFFFFF', 'color': '#000000', 'font-weight': 'bold'}
                        ]">
            {{ challengeTypes['single'] }}
          </argon-button>
          <argon-button fullWidth color="danger"
                        variant="gradient"
                        class="my-3 mb-1 me-2"
                        :class="{'challenge-type-active': 'global' === selectChallengeType}"
                        @click="challengeTypeChange('global')"
                        :style="[Object.keys(this.challengeTypes)[1] === selectChallengeType
                          ? {'background': '#8435e8', 'color': '#FFFFFF', 'font-weight': 'bold'}
                          : {'background': '#FFFFFF', 'color': '#000000', 'font-weight': 'bold'}
                        ]">
            {{ challengeTypes['global'] }}
          </argon-button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="category-title">
          {{ $t('SELECT_TOPIC_CATEGORY') }}
        </div>
      </div>
      <div class="col-lg-12 mb-2">
        <select class="form-select" v-model="selectedCategory" @change="categoryChange($event)">
          <option v-for="category in categoryList"
                  :key="category.id"
                  :value="category.id"
                  :selected="category.id === selectedCategory">
            {{ category.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="category-title">
          {{ $t('SELECT_TOPIC') }}
        </div>
      </div>
      <div class="col-lg-12 mb-2">
        <select class="form-select" v-model="selectedTopic" @change="topicChange($event)">
          <option v-for="topic in topicList"
                  :key="topic.topic_id"
                  :value="topic.topic_id"
                  :selected="topic.topic_id === selectedTopic">
            {{ topic.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="question-no-title">
          {{ $t('SELECT_QUESTION_AMOUNT') }}
        </div>
      </div>
      <div class="col-lg-12">
        <div class="question-no-section d-flex justify-content-between align-items-center">
          <div class="question-no">{{ convertNumberToLangWise(questionNo) }}</div>
          <div class="no-change d-flex">
            <div style="margin-right: 20px;" @click="decrement"><i class="fa fa-minus-circle"></i></div>
            <div><i class="fa fa-plus-circle" @click="increment"></i></div>
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="d-flex flex-column justify-content-center align-items-center mb-3">
        <div class="text-danger mb-2" v-if="error">{{ error }}</div>
        <argon-button full-width
            color="dark"
            variant="gradient"
            class="my-4"
            @click="confirmChallenge"
            style="background: #8435E8;" v-if="! challengeConfirm">{{ $t('CONFIRM') }}
        </argon-button>
        <argon-button full-width
            color="dark"
            variant="gradient"
            class="my-4"
            style="background: #8435E8;" v-if="challengeConfirm">{{ $t('CHALLENGE') }} {{ $t('CONFIRM') }}
        </argon-button>
      </div>
    </div>
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import ArgonButton from "@/components/ArgonButton";

export default {
  name: "ChallengeFriend",
  components: {
    Loader,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      friendId: this.$route.query.friend_id,
      budgetAmounts: [200, 500, 1000, 1500, 2000],
      challengeTypes: {
        'single': this.$t('SINGLE_TOPIC'),
        'global': this.$t('GLOBAL')
      },
      categoryList: [],
      topicList: [],
      selectBudgetAmount: '',
      selectChallengeType: '',
      selectedCategory: '',
      selectedTopic: '',
      questionNo: 30,
      challengeConfirm: false,
      error: '',
    }
  },
  created() {
    this.getCategoryList();
    this.getTopicList();
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    changeBudgetAmount(amount) {
      this.selectBudgetAmount = amount;
    },
    challengeTypeChange(type) {
      this.selectChallengeType = type;
    },
    categoryChange(event) {
      this.selectedCategory = event.target.value;
      this.getTopicList();
    },
    topicChange(event) {
      this.selectedTopic = event.target.value;
    },
    getCategoryList() {
      this.loaderActive = true;

      sendRequest('get', 'v2.0/categories', {}, this.config)
          .then( response => {
            this.loaderActive = false;
            this.selectBudgetAmount = this.budgetAmounts[0];
            this.selectChallengeType = Object.keys(this.challengeTypes)[0];
            this.categoryList = response.data.category_list;
            this.selectedCategory = this.categoryList[0].id;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getTopicList() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/topics', {category_id: this.selectedCategory}, this.config)
          .then( response => {
            this.loaderActive = false;
            this.topicList = response.data.topics;
            this.selectedTopic = this.topicList[0].topic_id;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    increment() {
      if (this.questionNo === 100) {
        return;
      }
      this.questionNo += 10
    },
    decrement() {
      if (this.questionNo === 10) {
        return;
      }
      this.questionNo -= 10
    },
    confirmChallenge() {
      let data = {
        bet: this.selectBudgetAmount,
        friend_user_id: this.friendId,
        number_of_question: this.questionNo,
        topic_id: this.selectedTopic,
      };
      this.error = '';
      sendRequest('post', 'v2.0/challenge/request', data, this.config)
          .then( response => {
            this.loaderActive = false;
            if (response.success) {
              this.challengeConfirm = true;
            } else {
              this.error = response.message;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    }
  }
}
</script>

<style scoped>

</style>
